export const DESKTOP_AVATAR_SIZE = 134;
export const MOBILE_AVATAR_SIZE = 80;
